import React, { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'

import CardsWithMediaPlayer from '../CardsWithMediaPlayer/CardsWithMediaPlayer'
import Headline from '../Headline/Headline'
import BenefitCard from '../BenefitCard/BenefitCard'
import BulletList from '../BulletList/BulletList'
import Button from '../ui/Button/Button'
import Image from '../ui/Image/Image'
import UPIBenefits from '../UpiLayout/UPIBenefits'
import { scrollElemToTop } from '../../utils'
import { Card } from 'react-bootstrap'
import PillarsSection from '../UpiLayout/PillarsSection'

import styles from './RemittanceLayout.module.scss'
import arrowUpRight from '../../assets/images/arrowUpRight.svg'

function RemittanceLayout({ cards, buttonText = '', hideVideo }) {
  let navigate = useNavigate()
  const infoRef = useRef(null)
  const [selectedCard, setSelectedCard] = useState(cards[0] || [])
  function cardClickHandler(card) {
    setSelectedCard(card)
  }

  const handleReadMoreClick = () => {
    if (infoRef.current) {
      scrollElemToTop(infoRef.current.offsetTop)
    }
  }

  const handleNavigation = (buttonDetails) => {
    if (buttonDetails?.isExternal) {
      return window.open(buttonDetails?.path, '_blank', 'noopener,noreferrer')
    }
    navigate(buttonDetails.path || '')
  }

  return (
    <div className={styles.container}>
      <CardsWithMediaPlayer
        selectedCard={selectedCard}
        cards={cards}
        cardClickHandler={cardClickHandler}
        handleReadMoreClick={handleReadMoreClick}
        buttonText={buttonText}
        hideVideo={hideVideo}
        className={'page-container'}
      />
      <div ref={infoRef} className={styles.infoContainer}>
        {selectedCard?.headlinetitle && (
          <Headline
            title={selectedCard?.headlinetitle}
            paragraphs={selectedCard?.headlinedecription}
            className={'page-container'}
          />
        )}
        {selectedCard?.headlinetitleadditional && (
          <Headline
            title={selectedCard?.headlinetitleadditional}
            paragraphs={selectedCard?.headline_desc_additional}
            className={'page-container'}
          />
        )}
        {/* {selectedCard?.headlinetitlenew && (
          <Headline
            title={selectedCard?.headlinetitlenew}
            paragraphs={selectedCard?.headline_desc_new}
            className={'page-container'}
          />
        )} */}
        {selectedCard?.pillertitle && (
          <PillarsSection
            title={selectedCard?.pillertitle}
            pillarsCards={selectedCard?.pillercontent || []}
            backgroundImage={selectedCard?.pillerimage}
            pillarsSectionClass={styles.pillarsSectionClass}
          />
        )}
        {selectedCard?.pillercontent.length > 0 &&
          selectedCard?.pillercontent.map((pillar, index) => (
            <Card
              key={'pillar' + pillar?.id}
              className={classNames(styles.pillarCard)}
              style={{
                marginBottom:
                  selectedCard.pillercontent.length - 1 === index && '0rem',
              }}
            >
              <div className={styles.cardNumber}>{index + 1}</div>
              <div className={styles.cardContent}>
                {pillar?.heading && <h2>{pillar.heading}</h2>}
                {pillar?.description && <p>{pillar.description}</p>}
              </div>
            </Card>
          ))}
        {selectedCard?.benefitscards &&
          selectedCard?.benefitscards?.length > 0 && (
            <div
              className={classNames(
                'page-container',
                styles.benefitsCardContainer
              )}
            >
              {selectedCard?.benefitscards &&
                selectedCard?.benefitscards.length > 0 && (
                  <div className={classNames(styles.benefitsCardsContainer)}>
                    {selectedCard?.benefitscards.map((card) => {
                      return (
                        <BenefitCard
                          key={'BenefitCard' + card?.id}
                          title={card.title}
                          description={card.description}
                          image={card.cardimage}
                        />
                      )
                    })}
                  </div>
                )}
            </div>
          )}
        {(selectedCard?.bulletstitle ||
          selectedCard?.button ||
          (selectedCard?.bulletssubsection &&
            selectedCard?.bulletssubsection?.length > 0)) && (
          <div
            className={classNames('page-container', styles.bulletsContainer)}
          >
            <div className={styles.descriptionHeaderContainer}>
              {selectedCard?.bulletstitle && (
                <h1>{selectedCard?.bulletstitle}</h1>
              )}
              {selectedCard?.button && (
                <Button
                  aria-label={selectedCard?.button?.label}
                  classname={styles.countryListButton}
                  buttonDetails={selectedCard?.button}
                  text={selectedCard?.button?.label}
                  handleClick={handleNavigation}
                >
                  <Image
                    src={arrowUpRight}
                    alt={selectedCard?.button?.label}
                    className={styles.btnImage}
                  />
                </Button>
              )}
            </div>
            {selectedCard?.bulletssubsection && (
              <BulletList
                bulletList={selectedCard?.bulletssubsection}
                className={styles.bulletListContainer}
              />
            )}
          </div>
        )}
      </div>
      {(selectedCard?.upibenefitsheader || selectedCard.upibenefits) && (
        <div
          className={classNames('page-container', styles.upibenefitsContainer)}
        >
          <h1>{selectedCard?.upibenefitsheader}</h1>
          {selectedCard?.upibenifits && (
            <UPIBenefits benefits={selectedCard.upibenifits} />
          )}
        </div>
      )}
    </div>
  )
}

export default RemittanceLayout
